// Pure helpers for staging dropped schemas as events and sequencing the list.
import { generateTempEventId } from '../tempIdGenerator';

/** True when the last page was full, implying more pages may exist. */
export const inferHasMore = (returnedCount, limit) => limit > 0 && returnedCount === limit;

/** Build a lightweight pending event from a schema (real scenarios built by backend on save). */
export const buildPendingSchemaEvent = (schema) => ({
  event_id: generateTempEventId(),
  schema_id: schema.id,
  event_name: schema.event_title,
  priority: schema.priority,
  isPendingSchema: true,
});

/** Return a new array with event_order set to 1..N in current array order. */
export const resequenceEvents = (events) =>
  events.map((event, index) => ({ ...event, event_order: index + 1 }));

/** Index of the event matching overId, or the end of the list when not found. */
export const resolveInsertIndex = (sortedEvents, overId) => {
  const index = sortedEvents.findIndex((event) => event.event_id === overId);
  return index >= 0 ? index : sortedEvents.length;
};

/** Splice a pending schema event into the order-sorted list and resequence. */
export const insertPendingSchemaEvent = (events, schema, insertIndex) => {
  const sorted = [...events].sort((a, b) => a.event_order - b.event_order);
  sorted.splice(insertIndex, 0, buildPendingSchemaEvent(schema));
  return resequenceEvents(sorted);
};

/** Events that were dropped from a schema and not yet persisted. */
export const getPendingSchemaEvents = (events) => events.filter((event) => event.isPendingSchema);
